<template>
    <main-content-wrapper>
      <step-marker :steps="['Podatki o kartici','Prijavni podatki']" :current="0" />
        <h1 class="text-md-center font-weight-regular">
            REGISTRACIJA
            <span>Registrirajte se s Tuš Cash & Carry klub kartico in koristite morebitne pogodbene popuste.</span>
        </h1>
        <v-layout justify-center row wrap fill-height >
            <v-flex xs12 md6 pl-5 pr-5 pt-4 pb-4 class="border">
                <split-content text="Podatki o Cash&Carry kartici"/>
                <div class="mt-4 mb-4 font-weight-bold">Vaš novi račun bomo povezali z vašo obstoječo kartico, ki ste jo dobili pri včlanitvi v Tuš C&C. Vpišite številko kartice in PIN številko.</div>
                <empty-space />
                <v-alert
                        :value="invalid_pin_card"
                        type="error"
                >
                    {{ invalid_pin_card_msg }}
                </v-alert>
                <v-form v-model="valid" @submit.prevent="" ref="form">
                    <card-number v-model="card" required label="Vpišite številko vaše kartice" :error-messages="card_error_messages" :rules="[checkCard]" ref="card_input" required  />
                    <pin-number v-model="pin" required label="Vpišite PIN številko vaše kartice" />
                    <router-link to="/pozabljena-pin">Pozabljena PIN številka kartice</router-link>
                    <empty-space />
                </v-form>
                    <v-btn depressed large block color="primary_action" @click="createAccount" :loading="loading">POTRDI</v-btn>
            </v-flex>
        </v-layout>
    </main-content-wrapper>
</template>

<script>
    import Router from '../router';
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import EmptySpace from "../components/EmptySpace";
    import CardNumber from "../components/CardNumber";
    import PinNumber from "../components/PINNumber";
    import {userService} from "../services";
    import validations from "../components/validations";
    import StepMarker from '@/components/StepMarker.vue'

    export default {
        name: "CreateAccountPickCard",
        components: { StepMarker, SplitContent, MainContentWrapper, EmptySpace, CardNumber, PinNumber},
        data: vm => ({
            loading: false,
            card: null,
            pin: null,
            invalid_pin_card: false,
            invalid_pin_card_msg: null,
            card_error_messages: null
        }),
        methods: {
            checkCard(v){
                this.card_error_messages = [];
                let noError = validations.checkCardNumberAll(v);
                if (noError === true){
                    userService.checkCard(v).then(
                        data => {
                            this.card_error_messages = null;
                            if (data.already_connected){
                                this.card_error_messages = ['Kartica je že povezana z email računom '+data['connected_email']+'.'];
                            }

                        },
                        error => {
                            if (error.message) {
                                this.card_error_messages = [error.message];
                            } else {
                                this.card_error_messages = ['Napaka pri preverjanju kartice.'];
                            }
                        }
                    );
                    return true;
                }
                return noError;
            },
            createAccount(){
                let isValid = this.$refs.form.validate();
                if (isValid) {
                    this.loading = true;
                    this.invalid_pin_card = false;
                    this.invalid_pin_card_msg = null;
                    userService.checkCard(this.card).then(
                        data => {
                            if (data.already_connected == false){
                                userService.checkCardPin(this.card, this.pin, true).then((data) => {
                                        Router.push('/ustvari/kartica/izbrana');
                                    },
                                    (error) => {
                                        this.invalid_pin_card = true;
                                        this.invalid_pin_card_msg = error.message;
                                    }
                                );
                            }
                        }
                    ).then(() => {
                        this.loading = false;
                    });

                }
            }
        }
    }
</script>

<style scoped>

</style>
